import { CellContext } from '@tanstack/react-table'
import clsx from 'clsx'

import { Log } from '@/types/logs'
import { useManageLogOriginalRoute } from '@/modules/CombinedLogs/hooks/useManageLogOriginalRoute'

import styles from '../../../ui/CombinedLogs.module.scss'
import { tableCellStyles } from '@/ui/Table'

interface Props extends CellContext<Log, string> {
    isDataLoading: boolean
}

export const Reference = ({ isDataLoading, row, getValue }: Props) => {
    const { getElementAttributes } = useManageLogOriginalRoute(isDataLoading)
    const value = getValue()

    return (
        <div>
            <p
                {...getElementAttributes({
                    className: clsx(tableCellStyles.bold, styles.reference),
                    isOriginalTrip: !!row.original.originalTrip,
                })}
            >
                {value || '-'}
            </p>

            {row.original.originalTrip && (
                <div className={styles.originalTripTitleContainer}>
                    <p className={tableCellStyles.bold}>Original trip:</p>
                </div>
            )}
        </div>
    )
}
